'use client'

// libraries
import clsx from 'clsx'

// components
import EmployeeCard from '/react4xp/components/EmployeeCard'
import Accordions from '/react4xp/components/Accordions'
import Publications from '/react4xp/components/Publications'

// utils
import useAccordionTableWrapper from '/react4xp/utils/useAccordionTableWrapper'

// css
import './index.scss'

// types
interface EmployeeProps {
    className?: string
    employee?: {
        name: string,
        role: string,
        place: string,
        tag: {
            label: string,
            href: string
        },
        tag2: {
            label: string,
            href: string
        },
        phone: {
            label: string,
            phone: string
        },
        email: {
            label: string,
            email: string
        },
        campus: {
            label: string,
            href: string
        },
        profileUrl: {
            label: string,
            href: string
            external?: boolean
        },
        linkedin?: {
            label: string,
            href: string
            external?: boolean
        },
        researchgate?: {
            label: string,
            href: string
            external?: boolean
        },
        profileImage: string
    }
    accordions?: {
        title: string,
        items: {
            title: string,
            content: string
        }[]
    }
    publications?: {
        title: string,
        items: {
            title?: string,
            items?: {
                title?: string,
                href?: {
                    href?: string
                    external?: boolean
                },
                intro?: string
                type?: string
            }[],
            href?: {
                href?: string
                external?: boolean
            },
            intro?: string
            type?: string
        }[],
        loadMoreLabel?: string
        initialCount?: number
        loadMoreCount?: number
    }
    breadcrumbs?: {
        label: string
        url?: string
    }[]
    region?: React.ReactNode
}

export default function Employee({
    className,
    employee,
    accordions,
    publications,
    breadcrumbs,
    region
}: EmployeeProps) {

    useAccordionTableWrapper()

    return (
        <div className={clsx('page-employee', className)}>

            <EmployeeCard
                color='green-light'
                image={{
                    src: employee?.profileImage,
                    alt: employee?.name
                }}
                title={employee?.name}
                position={employee?.role}
                location={employee?.place}
                tag={{
                    label: employee?.tag?.label,
                    href: employee?.tag?.href
                }}
                tag2={{
                    label: employee?.tag2?.label,
                    href: employee?.tag2?.href
                }}
                phone={{
                    label: employee?.phone?.label,
                    phone: employee?.phone?.phone
                }}
                email={{
                    label: employee?.email?.label,
                    email: employee?.email?.email
                }}
                map={{
                    label: employee?.campus?.label,
                    href: employee?.campus?.href
                }}
                linkedin={employee?.linkedin ? {
                    label: employee.linkedin.label,
                    href: employee.linkedin.href,
                    external: employee.linkedin.external
                } : undefined}
                researchgate={employee?.researchgate ? {
                    label: employee.researchgate.label,
                    href: employee.researchgate.href,
                    external: employee.researchgate.external
                } : undefined}
                fullProfile={{
                    label: employee?.profileUrl?.label,
                    href: employee?.profileUrl?.href,
                    external: employee?.profileUrl?.external
                }}
                breadcrumbs={breadcrumbs}
            />

            {region && (
                <>
                    {region}
                </>
            )}

            {publications?.items && publications.items.length > 0 && (
                <Publications
                    color='green-light'
                    title={publications?.title}
                    publications={[]}
                    publicationGroups={publications.items}
                    howManyPerPage={10}
                    loadMoreLabel={publications?.loadMoreLabel}
                    cardStyle='accordion'
                />
            )}

            <Accordions
                title={accordions?.title}
                color='beige'
                accordions={accordions?.items}
            />

        </div>
    )
}